import React, { useState } from 'react';
import TryhardH2 from '../../TryhardMarkups';
import TryhardPageFrame from '../TryhardPageFrame';
import { AnimatePresence, motion } from 'motion/react';
import useDebounce from '../../../../../../utils/hooks/useDebounce';

const TryhardContact: React.FC = () => {
    const [showCopied, setShowCopied] = useState(false);
    
    useDebounce(() => {
        setShowCopied(false);
    }, 2000, [showCopied])

    const handleOnClick = () => {
        navigator.clipboard.writeText('services@thgaming.gg');
        setShowCopied(true);
    }

    return (
        <TryhardPageFrame key='contact'>
            <div className='w-full py-4'>
                <div className='w-full flex flex-col justify-center items-center px-6 py-4 bg-white rounded-md bg-opacity-30 gap-y-2'>
                    <TryhardH2>Contact</TryhardH2>
                    <p className='text-center text-lg'>Grow your business with Tryhard merchandise. Send a message to us now to schedule a meeting (we'll come to YOU!)</p>
                    {/* <p className='text-red-950 text-3xl'>XXX - XX - XXX</p> */}
                    <div
                        className='relative p-2'
                        onClick={handleOnClick}
                    >
                        <p
                            className='text-red-950 italic text-3xl font-semibold hover:cursor-pointer'
                        >services@thgaming.gg</p>
                        <AnimatePresence>
                            {showCopied &&
                                <motion.div
                                    key={Math.random()}
                                    initial={{ y: 30, opacity: 0 }}
                                    animate={{ y: 0, opacity: 1 }}
                                    exit={{ y: -30, opacity: 0 }}
                                    className='absolute top-0 left-0 size-full rounded-sm bg-red-800 text-white text-3xl text-center text-teko px-4 py-2'
                                >
                                    Copied!
                                </motion.div>}
                        </AnimatePresence>
                    </div>
                </div>
            </div>
        </TryhardPageFrame>
    )
}

export default TryhardContact;